import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';
import '../styles/Matches.css';
import NotificationBell from '../components/NotificationBell';

export default function MatchesPage() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }

    try {
      const response = await API.get('/api/matches');
      setMatches(response.data.matches || []);
    } catch (err) {
      setMatches([]);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const handleMatchClick = (matchId) => {
    navigate(`/chat/${matchId}`);
  };

  const isNew = (matchedAt) => {
    const matchTime = new Date(matchedAt).getTime();
    const now = Date.now();
    return now - matchTime < 24 * 60 * 60 * 1000; // 24 hours
  };

  if (loading) {
    return (
      <div className="matches-page">
        <header className="matches-header">
          <h1>Matches</h1>
          <NotificationBell />
        </header>
        <div className="matches-loading">Loading matches...</div>
      </div>
    );
  }

  return (
    <div className="matches-page">
      <header className="matches-header">
        <h1>Matches</h1>
         <NotificationBell />
        <button
          className="refresh-icon"
          onClick={() => fetchMatches(true)}
          disabled={refreshing}
          title="Refresh"
        >
          {refreshing ? '⟳' : '↻'}
        </button>
      </header>

      {matches.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="matches-grid">
          {matches.map((match) => (
            <MatchCard
              key={match.match_id}
              match={match}
              isNew={isNew(match.matched_at)}
              onClick={() => handleMatchClick(match.match_id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function MatchCard({ match, isNew, onClick }) {
  return (
    <div className="match-card" onClick={onClick}>
      <div className="match-photo">
        {match.other_photo ? (
          <img src={match.other_photo} alt={match.other_full_name} />
        ) : (
          <div className="photo-placeholder">
            {match.other_full_name?.[0] || '?'}
          </div>
        )}
        {isNew && <span className="new-badge">New</span>}
        {match.unread_count > 0 && (
          <span className="unread-badge">{match.unread_count}</span>
        )}
      </div>
      <div className="match-info">
        <div className="match-name-row">
          <h3>{match.other_full_name}</h3>
          <span className="match-age">{match.other_age}</span>
        </div>
        <p className="match-preview">
          {match.last_message || 'Say hello'}
        </p>
      </div>
    </div>
  );
}

function EmptyState() {
  const navigate = useNavigate();
  return (
    <div className="matches-empty">
      <div className="empty-illustration">💔</div>
      <h2>No matches yet</h2>
      <p>Keep swiping to find your match.</p>
      <button onClick={() => navigate('/swipe')} className="empty-cta">
        Start swiping
      </button>
    </div>
  );
}